import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-cream relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6">
            <div className="pill text-cream/70 border-cream/30 mb-8" data-testid="footer-pill">
              <span className="pill-dot" />
              Members-only
            </div>
            <h3 className="h-display text-5xl md:text-7xl leading-[0.9]">
              Here now.<br />
              <span className="text-coral">Gone soon.</span>
            </h3>
            <p className="mt-8 text-cream/70 max-w-md text-base leading-relaxed">
              GoneSoon is a private local savings club offering members access to exclusive
              prices from selected places around the city.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-6">Navigate</div>
            <ul className="space-y-3 text-cream/90">
              <li><Link to="/" data-testid="footer-link-home" className="ed-link">Home</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="ed-link">About</Link></li>
              <li><a href="/#faq" data-testid="footer-link-faq" className="ed-link">FAQ</a></li>
              <li><a href="/#waitlist" data-testid="footer-link-join" className="ed-link">Join the list</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-6">City</div>
            <ul className="space-y-3 text-cream/90">
              <li>Trivandrum — Launching</li>
              <li className="text-cream/40">Kochi — Soon</li>
              <li className="text-cream/40">Bengaluru — Soon</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-cream/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-cream/50 uppercase tracking-[0.18em]">
          <div>© {new Date().getFullYear()} GoneSoon. All private drops reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-link-privacy" className="ed-link">Privacy</Link>
            <span>·</span>
            <Link to="/terms" data-testid="footer-link-terms" className="ed-link">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
